import React, { useContext, useReducer, useState } from "react";
import { FormContainer } from "../../uiwidgets/FormContainer";
import { PasswordField } from "../../uiwidgets/PasswordField";
import { PasswordResetDataReducer, passwdResetFormDataInitialState, AsyncResetPasswordDataHandlers } from "./PasswordResetDataReducer";
import { PasswordResetFormValidationReducer, passwordResetValidationInitialState } from "./PasswordResetFormValidationReducer";
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { validateInput } from './PasswordValidationService';
import { kickOffFullFormValidation } from 'util/Validators';
import { Spinner } from 'react-bootstrap';
import { SecurityContext } from '../../security/SecurityContext';
import { useNavigate } from "react-router-dom";
import { useReducerAsync } from "use-reducer-async";
import { Navigate } from "react-router-dom";

function PasswordResetPage() {

  const secCtx = useContext(SecurityContext);
  const [formData, formDispatchResetPassword] = useReducerAsync(PasswordResetDataReducer, passwdResetFormDataInitialState, AsyncResetPasswordDataHandlers);
  const [formValidityData, formValidityDispatch] = useReducer(PasswordResetFormValidationReducer, passwordResetValidationInitialState);

  const navigate = useNavigate();

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatchResetPassword({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleValidation = (event) => {
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value, formData: formData } })
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    let formDataEvent = {
      ...event,
      formData: formData,
      formDataIsIsolated: false
    }
    let isFormValid = kickOffFullFormValidation(formDataEvent, formValidityDispatch, validateInput);

    if (formData.newPassword !== formData.verifyNewPassword){
        isFormValid = false;
        formValidityDispatch({ type: 'VALIDATE_VERIFYNEWPASSWORD', payload: { verifyNewPassword: formData.verifyNewPassword, formData: formData } })
    }

    if (!isFormValid) {
      alert("The form still has validation errors!");
      return false;
    }

    let formDataObj = {
      ...formData,
      userId: secCtx.profile.id ? secCtx.profile.id : secCtx.profile.userId
    }

    formDispatchResetPassword({
      type: 'FORM_SUBMIT', payload: { formData: formDataObj }
    });

  }

  if (formData.success) {
    return (
      <>
        <Navigate to="/logout" replace />
      </>
    );

  } else {

    return (

      <FormContainer
        title="Reset Password"
        submitButtonFunction={handleSubmit}
        errors={formData.errors}
        infoMessage={formData.infoMessage}
      >
        {secCtx.profile.passwordExpired &&<span>The password has expired and must be changed. Use the temporary password from "password reset" email in the original password field.</span>}
        <br/><br/>
        Enter current or original and new passwords. When you click submit you will be logged out and redirected to login page. Use the new password to login.
        <br />
        <br />
        <PasswordField name="originalPassword" label="Original Password" value={formData['originalPassword']}
          placeholder="Enter Original Password" onChange={handleChange} onBlur={handleValidation}
          valstate={!formValidityData.originalPasswordError} valMsg={formValidityData.originalPasswordErrMsg} />

        <PasswordField name="newPassword" label="New Password" value={formData['newPassword']}
          placeholder="Enter New Password" onChange={handleChange} onBlur={handleValidation}
          valstate={!formValidityData.newPasswordError} valMsg={formValidityData.newPasswordErrMsg} />

        <PasswordField name="verifyNewPassword" label="Verify New Password" value={formData['verifyNewPassword']}
          placeholder="Verify New Password" onChange={handleChange} onBlur={handleValidation}
          valstate={!formValidityData.verifyNewPasswordError} valMsg={formValidityData.verifyNewPasswordErrMsg} />

        <br />

        <div>
          {formData.loading === true ? (
            <Spinner
              style={{ marginBottom: 27 }}
              animation="border"
              variant="success"
            />
          ) : <></>
          }
        </div>

        {formData?.successmessage?.success ?
          <div>
          </div>
          :
          <SubmitButton label='Submit' />
        }

      </FormContainer>

    )
  }

}

export default PasswordResetPage;